import { useContext, useEffect, useMemo, useState } from "react";
import { Column, usePagination, useSortBy, useTable } from "react-table";
import { getDefaultPageSize } from "../../../../helpers/utils";
import ReactTable from "../../../../component/ReactTable";
import { TimeRangeContext } from "../../../../context/TimeRangeContext";
import ObjectTuningApi from "../../../../api/object-tuning/ObjectTuningApi";
import IndexColumnsType from "../../../../types/ObjectBrowser/IndexColumnsType";
import TableColumnsType from "../../../../types/ObjectBrowser/TableColumnsType";
import Helper from "../../../../helpers/Helper";

const ColumnsTable = (props: { selectedItem: any }) => {
    const timeRangeContext = useContext(TimeRangeContext)
    const [columnsTable, setColumnsTable] = useState<IndexColumnsType[] | TableColumnsType[]>([]);
    const isIndex = props.selectedItem.objectType === 'Index'
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getTableColumns = async () => {
            const tableStatisticsData = await ObjectTuningApi.getTableColumns(timeRangeContext, props.selectedItem.instanceId, props.selectedItem.tablename, props.selectedItem.tableschema, props.selectedItem.database)
            setLoading(false)
            setColumnsTable(tableStatisticsData)
        }

        const getIndexColumns = async () => {
            const indexStatisticData = await ObjectTuningApi.getIndexColumns(timeRangeContext, props.selectedItem.instanceId, props.selectedItem.indexname, props.selectedItem.indexschema, props.selectedItem.database, props.selectedItem.tablename, props.selectedItem.tableschema)
            setLoading(false)
            setColumnsTable(indexStatisticData)
        }
        if (isIndex) {
            void getIndexColumns()
        } else {
            void getTableColumns()
        }

    }, [timeRangeContext, props.selectedItem]);
    const definitionColumns: Column[] = useMemo(() => [
        {
            Header: '#',
            accessor: 'ordinal',
            headerClassName: "text-nowrap",
            className: 'col-width-5',
        },
        {
            Header: 'Column Name',
            accessor: 'columnname',
            headerClassName: "text-nowrap",
        },
        {
            Header: 'Distinct',
            accessor: 'distinctvalues',
            headerClassName: "text-nowrap",
            className: "text-end",
        }
    ], []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize }
    } = useTable({
                columns: definitionColumns,
                data: columnsTable,
                initialState: {
                    pageIndex: 0,
                    pageSize: getDefaultPageSize(),
                    sortBy: [{ id: 'ordinal', desc: false }]
                }
            },
            useSortBy, usePagination);

    return (
            <div className="row row-cols-1 object-browser">
                <div className="col">
                    <div className="card">
                        <div className="card-header">
                            <i className="fa fa-table" style={{ color: "#4dc9b0", fontSize: 18, }} aria-hidden="true"></i> Columns
                            <span className="badge bg-info"
                                  data-tooltip-id="global-tooltip" data-tooltip-content="Total Columns count">{Helper.getFormattedBadgeCount(columnsTable.length)}</span>
                            <i className="collapse-toggle" role="button" data-bs-toggle="collapse" data-bs-target="#collapseObjectColumns" aria-expanded="false"
                               aria-controls="collapseObjectColumns"></i>
                        </div>
                        <div id="collapseObjectColumns" className="card-body collapse show" style={{ padding: 20 }}>
                            <ReactTable
                                getTableProps={getTableProps}
                                getTableBodyProps={getTableBodyProps}
                                headerGroups={headerGroups}
                                prepareRow={prepareRow}
                                page={page}
                                canPreviousPage={canPreviousPage}
                                canNextPage={canNextPage}
                                pageOptions={pageOptions}
                                pageCount={pageCount}
                                gotoPage={gotoPage}
                                nextPage={nextPage}
                                previousPage={previousPage}
                                setPageSize={setPageSize}
                                pageIndex={pageIndex}
                                pageSize={pageSize}
                                dataLength={columnsTable.length}
                                error={null}
                                loading={loading}
                            />
                        </div>
                    </div>
                </div>
            </div>
    );
}


export default ColumnsTable;
